<h1 mat-dialog-title>
  <span *ngIf="data.action === 'new'">{{ 'common.words.new' | translate }} - </span>
  {{ data.modalTitle }}
</h1>
<ng-container class="digital-document-wrapper" *ngIf="!docType && !docUploaded">
  <div class="row p-5">
    <div class="col-12">
      <div class="row">
        <div class="col-12 text-center mb-4">
          {{ 'properties.addDocumentsPage.docTypes.chooseMessage' | translate }}
        </div>
      </div>
      <div class="row">
        <div class="col-12 text-center">
          <button class="mr-2 mb-2" mat-stroked-button (click)="onChooseDocType('digital')" color="primary">
            {{ 'properties.addDocumentsPage.docTypes.digital' | translate }}
            <mat-icon fontSet="fal" fontIcon="fa-desktop"></mat-icon>
          </button>
          <button mat-stroked-button (click)="onChooseDocType('paper')" color="accent">
            {{ 'properties.addDocumentsPage.docTypes.paper' | translate }}
            <mat-icon fontSet="fal" fontIcon="fa-scroll"></mat-icon>
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <div class="text-left w-100">
        <a mat-button (click)="onClose()" mat-raised-button mat-default
          class="ml-3">{{ 'common.cta.close' | translate }}</a>
      </div>
    </div>
  </div>
</ng-container>
<ng-container *ngIf="docType && !docUploaded">
  <mat-dialog-content>
    <app-card-spinner [visible]="dialogIsLoading" type="zero"></app-card-spinner>

    <div class="form-wrapper mt-3">
      <form [formGroup]="form">
        <formly-form [form]="form" [fields]="fields" [model]="model" [options]="options"></formly-form>
        <div class="row mb-1">
          <div class="col-12" *ngFor="let item of existingNotes">
            <div class="note-preview-box">
              <div class="created-at" title="{{ item.createdAt }}">
                {{ item.createdAt | date }} - {{ item.createdBy }}
              </div>
              <div class="text">{{ item.text }}</div>
            </div>
          </div> <!-- /.col -->
        </div> <!-- ./row -->
      </form>
    </div> <!-- /.form-wrapper -->
  </mat-dialog-content> <!-- mat-dialog-content -->
  <div class="col-12 pb-4" mat-dialog-actions>
    <div class="col-6 text-left">
      <div class="w-100">
        <a mat-button (click)="onClose()" mat-raised-button mat-default
          class="ml-3">{{ 'common.cta.close' | translate }}</a>
      </div>
    </div>
    <div class="col-6 text-right">
      <mat-spinner-button (btnClick)="onFormSubmit(model)" role="submit" [options]="formBtnOptions" class="btn-elevate"
        *ngIf="data.action === 'edit' || data.action === 'new'">
      </mat-spinner-button>
    </div>
  </div>
</ng-container>
<ng-container class="digital-document-wrapper" *ngIf="docType && docUploaded">
  <div class="row p-5">
    <div class="col-12">
      <div class="row">
        <div class="col-12 text-center mb-4">
          {{ 'properties.addDocumentsPage.docTypes.successMessage' | translate }}
        </div>
      </div>
      <div class="row">
        <div class="col-12 text-center">
          <mat-spinner-button (btnClick)="onPrint('module')" [options]="printModuleBtnOptions" class="btn-elevate">
          </mat-spinner-button>
          <mat-spinner-button (btnClick)="onPrint('qr')" [options]="printQrBtnOptions" class="btn-elevate ml-2">
          </mat-spinner-button>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <div class="text-left w-100">
        <a mat-button (click)="onClose({ save: 'success' })" mat-raised-button mat-default
          class="ml-3">{{ 'common.cta.close' | translate }}</a>
      </div>
    </div>
  </div>
</ng-container>